<template>
    <v-dialog v-model="dialog" persistent max-width="520" scrollable>
      <v-card class="sfa-card">
  
        <!-- Header -->
        <div class="sfa-header">
          <div class="sfa-header-icon">
            <v-icon :style="{ color: 'white !important' }" size="26">mdi-send-check-outline</v-icon>
          </div>
          <div class="sfa-header-text">
            <div class="sfa-header-title">{{ $t('deforestation.submitForApproval') }}</div>
            <div class="sfa-header-sub">Review and confirm before submitting</div>
          </div>
          <v-btn icon small @click="$emit('cancel')" class="sfa-close-btn">
            <v-icon :style="{ color: 'white !important' }">mdi-close</v-icon>
          </v-btn>
        </div>
  
        <v-card-text class="sfa-body pa-0">
  
          <!-- Confirmation message -->
          <div class="sfa-message mx-4 mt-4">
            <v-icon size="18" color="primary" class="mr-2" style="flex-shrink:0; margin-top:1px;">mdi-information-outline</v-icon>
            <span class="text-body-2" style="color:#37474F; line-height:1.6;">{{ message }}</span>
          </div>
  
          <!-- Accuracy responsibility notice -->
          <div class="sfa-notice mx-4 mt-4 mb-4">
            <div class="d-flex align-start" style="gap:10px;">
              <v-icon color="#1565C0" size="20" style="margin-top:1px; flex-shrink:0;">mdi-shield-account-outline</v-icon>
              <div style="flex:1; min-width:0;">
                <div class="sfa-notice-title">Accuracy Responsibility Notice</div>
                <div class="sfa-notice-body mt-1">
                  The accuracy of all information and documentation remains entirely the responsibility of the cooperative and cannot be transferred to PTSI under any circumstances, whether before or after the assessment/scoring process.
                </div>
                <div class="sfa-ack-row mt-3">
                  <v-checkbox
                    v-model="acknowledged"
                    color="primary"
                    class="mt-0 pt-0"
                    hide-details
                  >
                    <template v-slot:label>
                      <span class="sfa-ack-label">
                        I acknowledge that the accuracy of all submitted information is the cooperative's responsibility.
                      </span>
                    </template>
                  </v-checkbox>
                </div>
              </div>
            </div>
          </div>
  
        </v-card-text>
  
        <!-- Footer -->
        <div class="sfa-footer">
          <v-btn text @click="$emit('cancel')" class="sfa-cancel-btn">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            depressed
            color="primary"
            class="sfa-submit-btn"
            :disabled="!acknowledged"
            @click="onConfirm"
          >
            <v-icon small :style="{ color: 'white !important' }" class="mr-2">mdi-send-outline</v-icon>
            {{ $t('deforestation.submitForApproval') }}
          </v-btn>
        </div>
  
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: 'SubmitForApprovalModal',
    props: {
      dialog: { type: Boolean, required: true },
      message: { type: String, default: '' },
    },
    data() {
      return {
        acknowledged: false,
      }
    },
    watch: {
      dialog(val) {
        if (!val) this.acknowledged = false
      },
    },
    methods: {
      onConfirm() {
        this.$emit('confirm')
        this.acknowledged = false
      },
    },
  }
  </script>
  
  <style scoped>
  .sfa-card { border-radius: 12px !important; overflow: hidden; }
  
  /* Header */
  .sfa-header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 18px;
    background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
  }
  .sfa-header-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255,255,255,0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .sfa-header-text { flex: 1; }
  .sfa-header-title { font-size: 15px; font-weight: 700; color: #fff; line-height: 1.3; }
  .sfa-header-sub { font-size: 12px; color: rgba(255,255,255,0.72); margin-top: 2px; }
  .sfa-close-btn { opacity: 0.8; }
  .sfa-close-btn:hover { opacity: 1; }
  
  /* Body */
  .sfa-body { overflow-y: auto; }
  
  /* Message row */
  .sfa-message {
    display: flex;
    align-items: flex-start;
    background: #F3F8FF;
    border: 1.5px solid #BBDEFB;
    border-radius: 8px;
    padding: 12px 14px;
  }
  
  /* Accuracy notice */
  .sfa-notice {
    background: #EBF5FF;
    border: 1.5px solid #90CAF9;
    border-radius: 10px;
    padding: 14px 16px;
  }
  .sfa-notice-title { font-size: 13px; font-weight: 700; color: #1565C0; }
  .sfa-notice-body { font-size: 12.5px; color: #37474F; line-height: 1.55; }
  .sfa-ack-row {
    background: rgba(255,255,255,0.65);
    border-radius: 6px;
    padding: 8px 10px;
  }
  .sfa-ack-label { font-size: 12px; font-weight: 600; color: #263238; line-height: 1.4; }
  
  /* Footer */
  .sfa-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 12px 18px;
    border-top: 1px solid #ECEFF1;
    background: #FAFAFA;
  }
  .sfa-cancel-btn { color: #607D8B !important; font-weight: 600; }
  .sfa-submit-btn { min-width: 180px; font-weight: 700; }
  </style>
  